import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { TableCell, TableHead, TableRow, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';

const ActivityLogHead = ({ sortDirection = 'desc', onSortChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSortClick = () => {
    const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    onSortChange && onSortChange(newSortDirection);
  };

  return (
    <TableHead>
      <TableRow className={classes.headerRow}>
        <TableCell
          className={classes.headerCell}
          style={{ width: '10%' }}
        >
          {t('inventory')}
        </TableCell>
        <TableCell
          className={classes.headerCell}
          style={{ width: '45%' }}
        >
          {t('description')}
        </TableCell>
        <TableCell
          className={classes.headerCell}
          style={{ width: '45%' }}
        >
          <div
            className={classes.sortableHeader}
            onClick={handleSortClick}
          >
            {t('timestamp').charAt(0).toUpperCase() + t('timestamp').slice(1)}
            <IconButton
              size="small"
              className={classes.sortIcon}
            >
              {sortDirection === 'asc' ? <ArrowUpward /> : <ArrowDownward />}
            </IconButton>
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default ActivityLogHead;
